import styled, { css } from 'styled-components';
import { alignItems, grid, justifyContent, justifyItems } from 'styled-system';

import { Box } from '@/components/Box';

import type { RowProps } from './Row';
import { defaultRowProps } from './Row';

const generateGridProps = (
  columns: number,
  gap: string,
  showRowGap?: boolean,
) => css`
  grid-template-columns: repeat(${columns}, 1fr);
  row-gap: ${showRowGap ? gap : 0};
`;

export const Row = styled(Box)<RowProps>`
  display: grid;
  ${grid};
  ${alignItems};
  ${justifyContent};
  ${justifyItems};
  ${({
    gapDensity = defaultRowProps.gapDensity,
    showRowGap,
    theme: { gridColumns, gridGap, mediaQueries },
  }) =>
    css`
      margin-inline: calc(-${gridGap[gapDensity].xs} / 2);
      ${generateGridProps(gridColumns.xs, gridGap[gapDensity].xs, showRowGap)};

      & > * {
        padding-inline: calc(${gridGap[gapDensity].xs} / 2);
      }

      ${mediaQueries.sm} {
        margin-inline: calc(-${gridGap[gapDensity].sm} / 2);
        ${generateGridProps(
          gridColumns.sm,
          gridGap[gapDensity].sm,
          showRowGap,
        )};

        & > * {
          padding-inline: calc(${gridGap[gapDensity].sm} / 2);
        }
      }
      ${mediaQueries.md} {
        margin-inline: calc(-${gridGap[gapDensity].md} / 2);
        ${generateGridProps(
          gridColumns.md,
          gridGap[gapDensity].md,
          showRowGap,
        )};

        & > * {
          padding-inline: calc(${gridGap[gapDensity].md} / 2);
        }
      }
      ${mediaQueries.lg} {
        margin-inline: calc(-${gridGap[gapDensity].lg} / 2);
        ${generateGridProps(
          gridColumns.lg,
          gridGap[gapDensity].lg,
          showRowGap,
        )};

        & > * {
          padding-inline: calc(${gridGap[gapDensity].lg} / 2);
        }
      }
      ${mediaQueries.xl} {
        margin-inline: calc(-${gridGap[gapDensity].xl} / 2);
        ${generateGridProps(
          gridColumns.xl,
          gridGap[gapDensity].xl,
          showRowGap,
        )};

        & > * {
          padding-inline: calc(${gridGap[gapDensity].xl} / 2);
        }
      }
    `}
`;
